import Vue from "vue";
import Vuex from "vuex";
import { getConfig, getJson } from "@/api";
import { HELP_CONFIG, GAME_SOCIAL_TYPES, FP_CN_GAMES } from "@/enum/const"

Vue.use(Vuex);

const state = {
  config: {},
  cscConf: [],
  bindInfo: {
    facebook: {
      name: '',
      email: ''
    },
    google: {
      name: '',
      email: ''
    },
    funplus_id: {
      name: '',
      email: ''
    }
  },
  socialLoginTypes: [],
  gameSource: 'global',
  help: '',
  FBFlag: false // FB 是否加载
};

const mutations = {
  setConf(state, data) {
    state.config = data;
  },
  setCsc(state, data) {
    state.cscConf = data;
  },
  setBindInfo (state, data) {
    state.bindInfo = {
      ...{
        facebook: {
          name: '',
          email: ''
        },
        google: {
          name: '',
          email: ''
        },
        funplus_id: {
          name: '',
          email: ''
        }
      },
      ...data
    }
  },
  setHelpUrl (state, data) {
    const gConf = HELP_CONFIG[data.gid] || {}
    state.help = gConf[data.source_id] || gConf.other
  },
  setBindInfoItem (state, data) {
    state.bindInfo = {
      ...state.bindInfo,
      [data.key]: {
        ...(state.bindInfo[data.key] || {}),
        ...data.value
      }
    }
  },
  setFbFlag (state, flag) {
    state.FBFlag = flag
  },
  setLoginTypes (state, gid) {
    state.socialLoginTypes = [...(GAME_SOCIAL_TYPES[gid] || ['Facebook', 'Google'])]
  },
  setGameSource (state, gid) {
    state.gameSource = FP_CN_GAMES.indexOf(Number(gid)) > -1 ? 'cn' : 'global'
  }
};

const actions = {
  async FETCH_CONF(context) {
    try {
      const countryCode = JSON.parse(window.localStorage.getItem('sdkParams')).country_code
      const res = await getConfig({ country_code: countryCode })
      context.commit("setConf", res);
      if (res.mobile_csc_country_list_url) {
        context.dispatch('FETCH_CSC', res.mobile_csc_country_list_url)
      }
    } catch (err) {
      console.log(err);
    }
  },
  FETCH_CSC(context, url) {
    getJson(url).then(res => {
      context.commit('setCsc', res)
    }).catch(err => console.log(err))
  }
};

const getters = {
  bindAccountNum ({ bindInfo }) {
    let flag = 0
    Object.values(bindInfo).forEach(item => {
      if (item.name || item.email) flag++
    })
    return flag
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});
